import { z } from "zod";

export const FilterSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  type: z.string().min(1),
  uid: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
});

export const PaginationSchema = z.object({
  page: z.number().int().positive(),
  pageSize: z.number().int().positive(),
  pageCount: z.number().int().positive(),
  total: z.number().int().nonnegative(),
});

export const MetaSchema = z.object({
  pagination: PaginationSchema,
});
